import styled from 'styled-components';

export const ToastContainer = styled.div`
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin: 1rem 0;
  gap: 1rem;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return `
          background-color: #e6f4ea;
          color: #276738;
          border: 1px solid #a5d6a7;
        `;
      case 'error':
        return `
          background-color: #fdecea;
          color: #b71c1c;
          border: 1px solid #ef9a9a;
        `;
      case 'info':
        return `
          background-color: #e3f2fd;
          color: #1565c0;
          border: 1px solid #90caf9;
        `;
      case 'warning':
        return `
          background-color: #fff8e1;
          color: #ff6f00;
          border: 1px solid #ffcc80;
        `;
      default:
        return '';
    }
  }}
`;

export const Content = styled.div`
  flex-direction: column;
  gap: 0.25rem;
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 1rem;
  padding-bottom: 0.2rem;
`;

export const Message = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.75rem;
  line-height: 1.6;
  a {
    color: #1565c0;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.25rem;
  color: inherit;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 10px;
  line-height: 1;
`;
